<template>
  <section id="hero">
    <!-- <v-img
      :height="minHeight"
      :src="require('@/assets/bg2.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .3), rgba(5, 11, 31, .3)"
    >-->
    <v-container class="fill-height">
      <v-responsive
        class="d-flex align-center"
        height="100%"
        max-width="1300"
        width="100%"
      >
        <base-heading title="Ship More, Save More" />

        <base-body style="font-size: 18px !important">
          <v-row style="border: 1px solid">
            <v-col cols="12" sm="12" md="3" lg="3" style="border: 1px solid">{{
              $i18n.t("Source")
            }}</v-col>
            <v-col cols="12" sm="12" md="3" lg="3" style="border: 1px solid">{{
              $i18n.t("Destination")
            }}</v-col>
            <v-col cols="12" sm="12" md="2" lg="2" style="border: 1px solid">{{
              $i18n.t("Date")
            }}</v-col>
            <v-col cols="12" sm="12" md="2" lg="2" style="border: 1px solid">{{
              $i18n.t("Material")
            }}</v-col>
            <v-col cols="12" sm="12" md="2" lg="2" style="border: 1px solid">{{
              $i18n.t("Truck Type")
            }}</v-col>
          </v-row>
          <v-row v-if="cargo" style="border: 1px solid">
            <v-col style="border: 1px solid" cols="12" sm="12" md="3" lg="3">{{
              cargo.src ? cargo.src.addressLine + ", " + cargo.src.city : ""
            }}</v-col>
            <v-col style="border: 1px solid" cols="12" sm="12" md="3" lg="3">{{
              cargo.dst ? cargo.dst.addressLine + ", " + cargo.dst.city : ""
            }}</v-col>
            <v-col style="border: 1px solid" cols="12" sm="12" md="2" lg="2">{{
              formatDate(cargo.tentativeDate)
            }}</v-col>
            <v-col style="border: 1px solid" cols="12" sm="12" md="2" lg="2">{{
              cargo.material
            }}</v-col>
            <v-col style="border: 1px solid" cols="12" sm="12" md="2" lg="2">{{
              cargo.truckType
            }}</v-col>
          </v-row>
        </base-body>

        <!-- <base-body style="font-size:18px !important">
            Use our freight ERP to digitize your day to day operation for more
            efficiency and cost saving.
          </base-body>

          <base-heading title="Freight Market" />

          <base-body style="font-size:18px !important">
            As a consigner or carrier, discover best rate transparently using
            our reverse auction engine. It's simple, reliable transparent and
            fast along with realtime tracking and secured delivery.
        </base-body>-->

        <!-- <div
          :class="
              $vuetify.breakpoint.smAndDown
                ? 'flex-column align-start'
                : 'align-center'
            "
          class="d-flex flex-wrap"
        >-->
        <div v-if="grid.records">
          <v-card
            v-for="tariff in grid.rows"
            :key="tariff._id"
            class
            elevation="1"
          >
            <rate-card
              :value="tariff"
              @bookNow="bookNow"
              @getQuote="getQuote"
            />
          </v-card>
        </div>
        <!-- </div> -->
      </v-responsive>
      <v-dialog v-model="showQuoteModel">
        <v-card>
          <v-card-text>
            <v-row v-if="cargo">
              <v-col>
                <v-text-field
                  v-model="cargo.wishPrice"
                  :label="$i18n.t('Wish Price')"
                  type="number"
                />
              </v-col>
              <v-col>
                <v-btn @click="saveQuote()">Submit Quote</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <!-- </v-img> -->
  </section>
</template>

<script>
import RateCard from "./RateCard";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import Themeable from "vuetify/lib/mixins/themeable";

@Component({
  name: "RateHero",
  components: { RateCard },
  provide: {
    theme: { isDark: true },
  },
  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
  },
})
export default class RateSelect extends (Vue, Themeable) {
  grid = { filters: {}, rows: [], records: 0, total: 0 };
  url = "/api/o/v1/search/car/rates?";
  // +"startTimestamp=1597170600&sourceCountry=India&sourceCity=Gurugram&source=JMD%20Megapolis,%20Sohna%20Road,%20Sector%2048,%20Gurugram,%20Haryana,%20India&startLatitude=28.4197368&startLongitude=77.0385656&destinationCountry=India&destinationCity=Gurugram&destination=JMD%20Garden,%20Sector%2033,%20Gurugram,%20Haryana,%20India&stopLatitude=28.4299008&stopLongitude=77.0321359";
  timezoneOffset = new Date().getTimezoneOffset() * 60;
  cargo = null;
  showQuoteModel = false;

  async search() {
    let filterUrl = "";
    if (this.cargo.truckType)
      filterUrl += "&vehicleType=" + this.cargo.truckType;
    if (this.cargo.currency) filterUrl += "&currency=" + this.cargo.currency;
    if (this.cargo.tentativeDate)
      filterUrl +=
        "&startTimestamp=" + this.getTime(this.cargo.tentativeDate, null);
    if (this.cargo.src && this.cargo.src.country) {
      filterUrl += "&sourceCountry=" + this.cargo.src.country;
      filterUrl += "&sourceCity=" + this.cargo.src.city;
      filterUrl += "&source=" + this.cargo.src.addressLine;
      filterUrl += "&startLatitude=" + this.cargo.src.lat;
      filterUrl += "&startLongitude=" + this.cargo.src.lon;
    }
    if (this.cargo.dst && this.cargo.dst.country) {
      filterUrl += "&destinationCountry=" + this.cargo.dst.country;
      filterUrl += "&destinationCity=" + this.cargo.dst.city;
      filterUrl += "&destination=" + this.cargo.dst.addressLine;
      filterUrl += "&stopLatitude=" + this.cargo.dst.lat;
      filterUrl += "&stopLongitude=" + this.cargo.dst.lon;
    }
    this.filterUrl = filterUrl;
    common.setLoading(true);
    await this.showPage();
  }

  async bookNow(rateCard) {
    try {
      common.setLoading(true);
      this.cargo.tariffStructure = rateCard.tariffStructure;
      this.cargo.vehicleType = rateCard.tariffStructure.vehicleType;
      const url = "/api/cargo/save";
      const response = await doPost(url, this.cargo);
      common.setLoading(false);
      common.showMessage("Cargo Reqest Saved Successfully.");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  getQuote(rateCard) {
    this.cargo.tariffStructure = rateCard.tariffStructure;
    this.cargo.vehicleType = rateCard.tariffStructure.vehicleType;
    this.cargo.corp_id = rateCard.vendor_id;
    this.cargo.client = rateCard.vendor_id;
    this.showQuoteModel = true;
  }

  async saveQuote() {
    if (!this.cargo.wishPrice) {
      common.setError("Provide you wish price.");
      return false;
    }
    try {
      common.setLoading(true);
      const response = await doPost("/api/quot/create", this.cargo);
      common.setLoading(false);
      common.showMessage("Cargo Quotation Request Saved.");
      this.showQuoteModel = false;
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async showPage() {
    this.grid = await doGet(this.url + this.filterUrl);
    common.setLoading(false);
  }

  async mounted() {
    this.cargo = this.$route.params.cargo;
    // console.log(this.cargo);
    if (this.cargo == null) {
      this.$router.push("/");
      return;
    }
    await this.search();
    // await this.showPage();
  }

  getTime(dt, time) {
    dt = dt.toString();
    const dateFormated =
      dt.substring(0, 4) + "-" + dt.substring(4, 6) + "-" + dt.substring(6, 8);
    const a = this.$moment(
      dateFormated + (time ? time : "T00:00:00.000Z")
    ).format("X");
    return parseInt(a) + this.timezoneOffset;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 80 : 240;
  }

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }
}
</script>
